import { render, staticRenderFns } from "./DomainInfo.vue?vue&type=template&id=6a40238c&scoped=true&"
import script from "./DomainInfo.vue?vue&type=script&lang=js&"
export * from "./DomainInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a40238c",
  null
  
)

export default component.exports